import { useState } from 'react';

interface Project {
  id: number;
  title: string;
  location: string;
  category: string;
  image: string;
  description: string;
}

const projects: Project[] = [
  {
    id: 1,
    title: 'Modern Composite Deck with Built-in Seating',
    location: 'Grand Rapids, MI',
    category: 'Composite Decks',
    image: 'https://public.readdy.ai/ai/img_res/e9d8606d58d0157ee1cf9321cfeecfbf.jpg',
    description: '400 sq ft Trex composite deck with custom built-in seating and modern cable railing system.'
  },
  {
    id: 2,
    title: 'Classic Cedar Deck with Pergola',
    location: 'Kentwood, MI',
    category: 'Wood Decks',
    image: 'https://readdy.ai/api/search-image?query=beautiful%20natural%20cedar%20wood%20deck%20with%20pergola%20structure%20in%20residential%20backyard%20with%20simple%20background%20showing%20quality%20lumber%20construction%20and%20traditional%20craftsmanship%20in%20warm%20natural%20lighting&width=800&height=600&seq=portfolio-2&orientation=landscape',
    description: '350 sq ft cedar deck featuring an integrated pergola for shade and architectural interest.'
  },
  {
    id: 3,
    title: 'Two-Tier Trex Deck with Lighting',
    location: 'Wyoming, MI',
    category: 'Trex Decks',
    image: 'https://readdy.ai/api/search-image?query=two%20level%20trex%20composite%20deck%20with%20integrated%20LED%20lighting%20in%20residential%20setting%20with%20simple%20background%20showing%20premium%20materials%20and%20professional%20multi-level%20construction%20in%20evening%20lighting&width=800&height=600&seq=portfolio-3&orientation=landscape',
    description: 'Multi-level Trex deck with integrated LED lighting and glass panel railings.'
  },
  {
    id: 4,
    title: 'Complete Deck Replacement',
    location: 'Rockford, MI',
    category: 'Deck Replacements',
    image: 'https://static.readdy.ai/image/68c02a6c7db1e4f446ae7031426f220f/83baadee1395a4a3980330a2589513db.png',
    description: 'Full tear-out and replacement with low-maintenance composite decking and aluminum railings.'
  },
  {
    id: 5,
    title: 'Spacious Composite Entertainment Deck',
    location: 'Ada, MI',
    category: 'Composite Decks',
    image: 'https://readdy.ai/api/search-image?query=large%20spacious%20composite%20deck%20with%20entertainment%20area%20and%20outdoor%20kitchen%20space%20in%20residential%20setting%20with%20simple%20background%20showing%20premium%20quality%20construction%20in%20natural%20daylight&width=800&height=600&seq=portfolio-5&orientation=landscape',
    description: '600 sq ft composite deck designed for outdoor entertaining with dedicated grilling area.'
  },
  {
    id: 6,
    title: 'Pressure-Treated Wood Deck',
    location: 'Cascade, MI',
    category: 'Wood Decks',
    image: 'https://readdy.ai/api/search-image?query=pressure%20treated%20wood%20deck%20with%20natural%20brown%20tones%20in%20residential%20backyard%20with%20simple%20clean%20background%20showing%20quality%20lumber%20construction%20and%20traditional%20craftsmanship%20in%20natural%20outdoor%20lighting&width=800&height=600&seq=portfolio-6&orientation=landscape',
    description: '300 sq ft pressure-treated deck with classic wood railings and stairs.'
  },
  {
    id: 7,
    title: 'Trex Transcend Island Mist Deck',
    location: 'Grandville, MI',
    category: 'Trex Decks',
    image: 'https://static.readdy.ai/image/68c02a6c7db1e4f446ae7031426f220f/bff65c358809125788a47e5b2950546c.png',
    description: 'Premium Trex Transcend decking in Island Mist with matching fascia and Trex railing.'
  },
  {
    id: 8,
    title: 'Deck Restoration and Upgrade',
    location: 'Jenison, MI',
    category: 'Deck Replacements',
    image: 'https://static.readdy.ai/image/68c02a6c7db1e4f446ae7031426f220f/032af2e54cd8290cb732e5d29e4d4624.png',
    description: 'Structural repair with new composite decking boards and upgraded railing system.'
  },
  {
    id: 9,
    title: 'TimberTech Composite Deck',
    location: 'Byron Center, MI',
    category: 'Composite Decks',
    image: 'https://readdy.ai/api/search-image?query=timbertech%20composite%20deck%20with%20rich%20brown%20tones%20in%20residential%20setting%20with%20simple%20clean%20background%20showing%20premium%20quality%20materials%20and%20professional%20installation%20craftsmanship%20in%20natural%20daylight&width=800&height=600&seq=portfolio-9&orientation=landscape',
    description: '450 sq ft TimberTech deck with hidden fasteners and composite railing system.'
  },
  {
    id: 10,
    title: 'Redwood Deck with Custom Features',
    location: 'East Grand Rapids, MI',
    category: 'Wood Decks',
    image: 'https://readdy.ai/api/search-image?query=beautiful%20redwood%20deck%20with%20custom%20features%20and%20warm%20natural%20tones%20in%20residential%20backyard%20with%20simple%20background%20showing%20quality%20lumber%20construction%20and%20traditional%20craftsmanship%20in%20golden%20hour%20lighting&width=800&height=600&seq=portfolio-10&orientation=landscape',
    description: 'Premium redwood deck with custom bench seating and planter boxes.'
  },
  {
    id: 11,
    title: 'Trex Select Deck with Stairs',
    location: 'Walker, MI',
    category: 'Trex Decks',
    image: 'https://static.readdy.ai/image/68c02a6c7db1e4f446ae7031426f220f/341c0e81532848ff2b910f35d23f6b11.png',
    description: 'Trex Select decking with wide stairs and aluminum railing for easy backyard access.'
  },
  {
    id: 12,
    title: 'Full Deck Rebuild',
    location: 'Hudsonville, MI',
    category: 'Deck Replacements',
    image: 'https://static.readdy.ai/image/68c02a6c7db1e4f446ae7031426f220f/8d6eee386908f25c24ef77a0e38e235a.png',
    description: 'Complete rebuild from foundation to finish with composite decking and modern railings.'
  }
];

const categories = ['All', 'Composite Decks', 'Wood Decks', 'Trex Decks', 'Deck Replacements'];

export default function PortfolioPage() {
  const [selectedCategory, setSelectedCategory] = useState('All');
  const [selectedProject, setSelectedProject] = useState<Project | null>(null);

  const filteredProjects = selectedCategory === 'All' 
    ? projects 
    : projects.filter(p => p.category === selectedCategory);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div className="min-h-screen bg-white">
      {/* Navigation */}
      <nav className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-sm shadow-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-20">
            <a href="/" className="text-2xl font-bold text-gray-900 cursor-pointer">
              West Michigan Decks
            </a>
            
            <div className="hidden md:flex items-center gap-8">
              <a href="/" className="text-gray-700 hover:text-gray-900 font-medium transition-colors cursor-pointer">Home</a>
              <a href="/#services" className="text-gray-700 hover:text-gray-900 font-medium transition-colors cursor-pointer">Services</a>
              <a href="/portfolio" className="text-orange-600 font-medium cursor-pointer">Portfolio</a>
              <a href="/#faq" className="text-gray-700 hover:text-gray-900 font-medium transition-colors cursor-pointer">FAQ</a>
              <a 
                href="/#quote-form"
                className="bg-orange-600 text-white px-6 py-3 rounded-lg font-semibold hover:bg-orange-700 transition-colors whitespace-nowrap cursor-pointer"
              >
                Get Free Quote
              </a>
            </div>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="pt-32 pb-16 px-4 sm:px-6 lg:px-8 bg-gradient-to-br from-gray-50 to-white">
        <div className="max-w-6xl mx-auto text-center">
          <div className="inline-flex items-center gap-2 bg-orange-100 text-orange-800 px-4 py-2 rounded-full text-sm font-semibold mb-6">
            <i className="ri-gallery-line"></i>
            Our Work
          </div>
          
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-gray-900 mb-6">
            Completed Deck Projects in West Michigan
          </h1>
          
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Browse our portfolio of custom decks built for homeowners throughout Grand Rapids and West Michigan. Quality craftsmanship in every project.
          </p>
        </div>
      </section>

      {/* Filter Section */}
      <section className="py-8 px-4 sm:px-6 lg:px-8 bg-white sticky top-20 z-40 border-b border-gray-200">
        <div className="max-w-6xl mx-auto">
          <div className="flex flex-wrap justify-center gap-3">
            {categories.map((category) => (
              <button
                key={category}
                onClick={() => setSelectedCategory(category)}
                className={`px-6 py-2 rounded-full font-semibold transition-all whitespace-nowrap cursor-pointer ${
                  selectedCategory === category
                    ? 'bg-orange-600 text-white shadow-md'
                    : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                }`}
              >
                {category}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Gallery Grid */}
      <section className="py-16 px-4 sm:px-6 lg:px-8 bg-white">
        <div className="max-w-6xl mx-auto">
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {filteredProjects.map((project) => (
              <div
                key={project.id}
                onClick={() => setSelectedProject(project)}
                className="group cursor-pointer bg-white rounded-xl overflow-hidden shadow-sm border border-gray-200 hover:shadow-xl transition-all duration-300"
              >
                <div className="relative h-64 overflow-hidden">
                  <img
                    src={project.image}
                    alt={project.title}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/0 to-black/0 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                    <div className="absolute bottom-4 left-4 right-4">
                      <div className="flex items-center gap-2 text-white text-sm">
                        <i className="ri-eye-line"></i>
                        <span>View Details</span>
                      </div>
                    </div>
                  </div>
                </div>
                
                <div className="p-5">
                  <div className="inline-block bg-orange-100 text-orange-800 text-xs font-semibold px-3 py-1 rounded-full mb-3">
                    {project.category}
                  </div>
                  <h3 className="font-bold text-gray-900 text-lg mb-2 line-clamp-2">
                    {project.title}
                  </h3>
                  <div className="flex items-center gap-2 text-gray-600 text-sm">
                    <i className="ri-map-pin-line"></i>
                    <span>{project.location}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Lightbox Modal */}
      {selectedProject && (
        <div
          className="fixed inset-0 bg-black/90 z-50 flex items-center justify-center p-4"
          onClick={() => setSelectedProject(null)}
        >
          <button
            onClick={() => setSelectedProject(null)}
            className="absolute top-4 right-4 w-12 h-12 bg-white/10 hover:bg-white/20 rounded-full flex items-center justify-center text-white text-2xl transition-colors cursor-pointer"
          >
            <i className="ri-close-line"></i>
          </button>

          <div
            className="bg-white rounded-2xl max-w-4xl w-full max-h-[90vh] overflow-y-auto"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="relative h-96">
              <img
                src={selectedProject.image}
                alt={selectedProject.title}
                className="w-full h-full object-cover"
              />
            </div>
            
            <div className="p-8">
              <div className="inline-block bg-orange-100 text-orange-800 text-sm font-semibold px-4 py-2 rounded-full mb-4">
                {selectedProject.category}
              </div>
              
              <h2 className="text-3xl font-bold text-gray-900 mb-3">
                {selectedProject.title}
              </h2>
              
              <div className="flex items-center gap-2 text-gray-600 mb-6">
                <i className="ri-map-pin-line text-xl"></i>
                <span className="text-lg">{selectedProject.location}</span>
              </div>
              
              <p className="text-gray-700 text-lg leading-relaxed mb-8">
                {selectedProject.description}
              </p>

              <div className="flex flex-wrap gap-4">
                <a
                  href="/#quote-form"
                  className="bg-orange-600 text-white px-8 py-4 rounded-lg font-bold hover:bg-orange-700 transition-colors whitespace-nowrap cursor-pointer inline-flex items-center gap-2"
                >
                  <i className="ri-file-list-line"></i>
                  Get a Similar Quote
                </a>
                <button
                  onClick={() => setSelectedProject(null)}
                  className="bg-gray-100 text-gray-700 px-8 py-4 rounded-lg font-bold hover:bg-gray-200 transition-colors whitespace-nowrap cursor-pointer"
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* CTA Section */}
      <section className="py-20 px-4 sm:px-6 lg:px-8 bg-gradient-to-br from-orange-600 to-orange-700">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl sm:text-5xl font-bold text-white mb-6">
            Ready to Start Your Deck Project?
          </h2>
          <p className="text-xl text-white/90 mb-8">
            Get a free quote and see how we can transform your outdoor space
          </p>
          <a
            href="/#quote-form"
            onClick={scrollToTop}
            className="inline-block bg-white text-orange-600 px-10 py-5 rounded-lg text-xl font-bold hover:bg-gray-50 transition-colors whitespace-nowrap cursor-pointer shadow-2xl"
          >
            Request My Free Quote
          </a>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-16 px-4 sm:px-6 lg:px-8">
        <div className="max-w-6xl mx-auto">
          <div className="grid md:grid-cols-3 gap-12 mb-12">
            <div>
              <h3 className="text-2xl font-bold mb-4">West Michigan Decks</h3>
              <p className="text-gray-400 mb-4">
                Professional deck building services for homeowners throughout West Michigan.
              </p>
              <div className="flex items-center gap-2 text-gray-400">
                <i className="ri-phone-line"></i>
                <span>(616) 555-DECK</span>
              </div>
            </div>

            <div>
              <h4 className="font-bold text-lg mb-4">Service Areas</h4>
              <ul className="space-y-2 text-gray-400">
                <li>Grand Rapids</li>
                <li>Wyoming</li>
                <li>Kentwood</li>
                <li>Rockford</li>
                <li>Ada</li>
                <li>Cascade</li>
                <li>Grandville</li>
                <li>Jenison</li>
              </ul>
            </div>

            <div>
              <h4 className="font-bold text-lg mb-4">Services</h4>
              <ul className="space-y-2 text-gray-400">
                <li>New Deck Construction</li>
                <li>Composite Deck Installation</li>
                <li>Trex Deck Installation</li>
                <li>Wood Deck Building</li>
                <li>Deck Replacement</li>
                <li>Deck Repair</li>
              </ul>
            </div>
          </div>

          <div className="border-t border-gray-800 pt-8 flex flex-col sm:flex-row justify-between items-center gap-4">
            <p className="text-gray-400 text-sm">
              © 2026 West Michigan Decks. All rights reserved.
            </p>
            <a 
              href="https://readdy.ai/?ref=logo" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-gray-400 hover:text-white text-sm transition-colors cursor-pointer"
            >
              Website Builder
            </a>
          </div>
        </div>
      </footer>
    </div>
  );
}
